import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { pageTitle } from "./hooks/usePageTitle";

// `nx serve golden-ui --configuration=mock` builds in "mock" mode, which serves the
// API from fixtures. No other build includes the mocks.
const startMockApiInMockMode = async (): Promise<void> => {
  if (import.meta.env.MODE !== "mock") return;
  const { startMockApi } = await import("./mocks/browser");
  await startMockApi();
};

const render = (): void => {
  document.title = pageTitle();
  const root = document.getElementById("root");
  if (!root) throw new Error("index.html has no #root element");
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
};

void startMockApiInMockMode().then(render);
